import React, { useState, useCallback } from "react";
import { useDropzone } from "react-dropzone";
import { pdfjs, Document, Page } from "react-pdf";
import { toast } from "react-toastify";
import { postAttachments } from "../services/soar";

function FileUpload({
  objectId,
  objectType,
  header,
  savedFiles,
  loadFiles,
  printImg,
}) {
  // const [uploading, setUploading] = useState(false);
  const [showPreviews, setShowPreviews] = useState(false);
  const safyInfo = JSON.parse(localStorage.getItem("safyInfo"));
  const onDrop = useCallback(
    (acceptedFiles, rejectedFiles) => {
      const org = process.env.REACT_APP_ENVIRONMENT;
      const toastMessage =
        acceptedFiles.length > 1
          ? `Uploading File 1 of ${acceptedFiles.length}...`
          : "Uploading File...";
      const toastId = toast.info(toastMessage, { progress: 0 });
      const localSafyInfo = JSON.parse(localStorage.getItem("safyInfo"));

      acceptedFiles.forEach(async (file, index) => {
        try {
          // setUploading(true);
          const reader = new FileReader();
          reader.onabort = () => console.log("file reading was aborted");
          reader.onerror = () => console.log("file reading has failed");
          reader.onload = async () => {
            const newFile = {
              command: "insert",
              fileid: null,
              objectid: objectId,
              objecttype: objectType,
              objectenvironment: org,
              filename: file.name,
              filetype: file.type,
              filesize: file.size,
              filecontent: await reader.result,
              createdbyid: localSafyInfo.user.azureId,
              createdbyname: localSafyInfo.user.displayName,
            };
            console.log("New File", newFile, reader.result);
            const obj = {
              data: {
                files: [newFile],
              },
            };
            console.log("Posting Files", obj);
            const response = await postAttachments(obj);
            console.log(response);
            const progress = (index + 1) / acceptedFiles.length;

            if (progress < 1) {
              toast.update(toastId, {
                render: `Uploading File ${index + 1} of ${
                  acceptedFiles.length
                }...`,
                progress: progress,
              });
            } else {
              toast.update(toastId, {
                render: `File(s) uploaded successfully.`,
                isLoading: false,
                type: toast.TYPE.SUCCESS,
                autoClose: 5000,
                closeOnClick: true,
              });
              loadFiles();
            }
          };
          reader.readAsDataURL(file);
          // setUploading(false);
        } catch (error) {
          console.log("Error reading file:", error);
          toast.error("Error reading file...");
        }
      });

      if (rejectedFiles.length > 0) {
        console.log("Rejected Files", rejectedFiles);
        toast.error(
          <div>
            <div>
              <b>{`Rejected Files (${rejectedFiles[0].errors[0].code})`}</b>
            </div>
            <div>
              {rejectedFiles.map((file) => (
                <div key={file.file.name}>{file.file.name}</div>
              ))}
            </div>
          </div>
        );
      }
    },
    [objectId, objectType, loadFiles]
  );

  const { getRootProps, getInputProps } = useDropzone({
    onDrop,
    accept: {
      "image/png": [".png"],
      "image/jpeg": [".jpg", ".jpeg"],
      "application/pdf": [".pdf"],
    },
  });

  pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

  // const uploadFiles = async () => {
  //   setUploading(true);
  //   const obj = {
  //     data: {
  //       files: files,
  //     },
  //   };
  //   console.log("Posting Files", obj);
  //   postAttachments(obj).then((response) => {
  //     console.log(response);
  //     setFiles([]);
  //     setUploading(false);
  //     getFiles();
  //   });
  // };

  const preview = (file) => {
    switch (file.FileType) {
      case "image/jpeg":
      case "image/png":
        return (
          <img
            src={file.FileContent}
            alt={file.FileName}
            className="img-fluid p-2"
            onClick={() => openInNewTab(file.FileContent)}
          />
        );
      case "application/pdf":
        return previewPdf(file.FileContent);
      default:
        return <div className="p-4 text-info">Preview Not Available</div>;
    }
  };

  const openInNewTab = (fileContent) => {
    let image = new Image();
    image.src = fileContent;
    let w = window.open("");
    w.document.write(image.outerHTML);
  };

  const previewPdf = (fileContent) => {
    const blob = base64toBlob(fileContent);
    const url = URL.createObjectURL(blob);
    return (
      <div>
        <Document file={url} onClick={() => window.open(url)}>
          <Page
            style={{ width: "100%" }}
            pageNumber={1}
            renderTextLayer={false}
            renderAnnotationLayer={false}
          />
        </Document>
      </div>
    );
  };

  const base64toBlob = (data) => {
    const base64WithoutPrefix = data.substr(
      "data:application/pdf;base64,".length
    );
    const bytes = atob(base64WithoutPrefix);
    let length = bytes.length;
    let out = new Uint8Array(length);

    while (length--) {
      out[length] = bytes.charCodeAt(length);
    }

    return new Blob([out], { type: "application/pdf" });
  };

  const download = (file) => {
    const linkSource = file.FileContent;
    const downloadLink = document.createElement("a");
    document.body.appendChild(downloadLink);

    downloadLink.href = linkSource;
    downloadLink.target = "_self";
    downloadLink.download = file.FileName;
    downloadLink.click();
  };

  // const removeFileFromUpload = (file) => {
  //   console.log("Removing File", file);
  //   setFiles((prevFiles) => prevFiles.filter((f) => f !== file));
  // };

  const deleteFile = async (file) => {
    const toastId = toast.error("Deleting Attachment...");
    const obj = {
      data: {
        files: [
          {
            command: "delete",
            fileid: file.FileId,
            objectid: file.ObjectId,
            objecttype: file.ObjectType,
            objectenvironment: file.ObjectEnvironment,
            filename: file.FileName,
            filetype: file.FileType,
            filesize: file.FileSize,
            filecontent: file.FileContent,
            createdbyid: file.CreatedById,
            createdbyname: file.CreatedByName,
          },
        ],
      },
    };
    const response = await postAttachments(obj);
    console.log(response);
    if (response.SystemResponse[0].Code === "success") {
      toast.update(toastId, {
        render: "Attachment deleted successfully.",
        isLoading: false,
        type: toast.TYPE.SUCCESS,
        autoClose: 5000,
        closeOnClick: true,
      });
    } else {
      toast.update(toastId, {
        render: "There was an error in deleting attachment.",
        isLoading: false,
        type: toast.TYPE.ERROR,
        autoClose: 5000,
        closeOnClick: true,
      });
    }
    loadFiles();
  };

  return objectId && objectType ? (
    <div className="mt-4">
      {savedFiles.length > 0 ? (
        <>
          <div className="border rounded p-4 mt-4 d-print-none">
            <div className="row mb-4">
              <div className="col-10 h5">Saved Files</div>
              <div className="col-2">
                <div className="float-right w-100">
                  {showPreviews === true ? (
                    <div
                      className="btn btn-sm btn-danger"
                      onClick={() => setShowPreviews(!showPreviews)}
                    >
                      Hide Previews
                    </div>
                  ) : (
                    <div
                      className="btn btn-sm btn-primary float-right"
                      onClick={() => setShowPreviews(!showPreviews)}
                    >
                      Show Previews
                    </div>
                  )}
                </div>
              </div>
            </div>
            <div className="row">
              {savedFiles.map((file) => (
                <div key={file.FileId} className="w-25">
                  <div className="border rounded bg-light">
                    <button
                      className="btn btn-link w-100 text-truncate px-1 pt-2"
                      onClick={() => download(file)}
                    >
                      {file.FileName}
                    </button>
                    <div>
                      <button
                        // className="btn btn-primary m-0 ms-2"
                        className="btn btn-link text-decoration-none m-0 ms-2"
                        onClick={() => download(file)}
                      >
                        <i className="fas fa-save mx-2" />
                      </button>
                      {safyInfo.user.modules.includes("Admin") ||
                      safyInfo.user.displayName === file.CreatedByName ? (
                        <button
                          // className="btn btn-danger m-0 ms-2"
                          className="btn btn-link m-0 ms-2"
                          onClick={() => deleteFile(file)}
                        >
                          <i
                            className="fas fa-trash text-danger mx-2"
                            onClick={() => deleteFile(file)}
                          />
                        </button>
                      ) : null}
                    </div>
                    <div className="px-1">
                      {`${file.CreatedByName} - ${new Date(
                        file.DateCreatedUTC
                      ).toLocaleDateString()}`}
                    </div>
                    {showPreviews ? preview(file) : null}
                  </div>
                </div>
              ))}
            </div>
          </div>
          {printImg ? (
            <div className="d-none d-print-inline">
              {savedFiles
                .filter((file) => file.FileType.includes("image"))
                .map((file) => (
                  <div>
                    <img
                      src={file.FileContent}
                      alt={file.FileName}
                      className="img-fluid p-2"
                    />
                  </div>
                ))}
            </div>
          ) : null}
        </>
      ) : null}
      <div className="d-print-none">
        <div className="my-4">{header}</div>
        <div
          className="rounded safy-border-2 border-primary p-2 m-4"
          {...getRootProps()}
        >
          <input {...getInputProps()} />

          <p className="fw-bold m-4 p-0 text-center">
            Drag files here, or click here to select files
          </p>
        </div>
      </div>
      {/* {files.length > 0 ? (
        <>
          <div className="mb-2 ps-4 ms-4">
            <h4>Files To Upload</h4>
            {files.map((file, index) => (
              <li key={`${file.filename}-${index}`}>
                {`${file.filename} - ${file.filesize} bytes`}
                <i
                  className="fas fa-trash text-danger ps-2"
                  onClick={() => removeFileFromUpload(file)}
                />
              </li>
            ))}
          </div>
          {uploading === true ? (
            <div className="row col-2 d-flex justify-content-center align-items-center">
              <LottieFileFolder />
            </div>
          ) : (
            <div className="btn btn-primary" onClick={() => uploadFiles()}>
              Upload
            </div>
          )}
        </>
      ) : null} */}
    </div>
  ) : null;
}

export default FileUpload;
